// axios捕错
export const throwErr = (code: Number, response: any) => {
    let message = '请求错误'
    switch (code) {
        case 400:
            message = '请求错误'
            break
        case 403:
            message = '拒绝访问'
            break
        case 404:
            message = `请求地址出错: ${response.config.url}`
            break
        case 500:
            message = '服务器错误'
            break
        case 502:
            message = '网关错误'
            break
        default:
            message = '网络错误'
            break
    }
    return message
}

